import { gql } from 'graphql-request'

export const UNLINK_LINE_PROVIDER = gql`
  mutation UnlinkLineProvider {
    unlinkLineProvider {
      message
    }
  }
`
